import React from "react";
import Seo from "../components/shared/seo";
import Hero from "../components/privacyPage/hero";
import Layout from "../components/shared/layout";
import { useIntl } from "gatsby-plugin-react-intl";

function Privacy() {
  const intl = useIntl();
  return (
    <Layout>
      <Seo
        title={intl.formatMessage({
          id: "PrivacyPageTitle",
        })}
        description={intl.formatMessage({
          id: "PrivacyPageDescription",
        })}
      />
      <Hero />
    </Layout>
  );
}

export default Privacy;
